import { render } from "./VService.vue?vue&type=template&id=57bc3c5e"
import script from "./VService.vue?vue&type=script&lang=ts"
export * from "./VService.vue?vue&type=script&lang=ts"

import "./VService.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script